if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      observer = undefined

      constructor() {
        super()
      }

      connectedCallback() {
        const limit = parseInt(this.dataset.limit, 10) || 4
        const currentId = this.dataset.productId || ''
        const ids = this.getStoredIds()
          .filter((id) => id !== currentId)
          .slice(0, limit)

        if (!ids.length) {
          if (!(window.Shopify && Shopify.designMode)) this.hideSection()
          return
        }

        this.initializeRecommendations(ids)
      }

      getStoredIds() {
        let ids = []
        try {
          const stored = JSON.parse(
            localStorage.getItem('recently-viewed-products')
          )
          if (Array.isArray(stored)) ids = stored
        } catch (error) {
          console.warn('Could not parse recently viewed products', error)
        }
        return ids.map((id) => String(id))
      }

      initializeRecommendations(ids) {
        this.observer?.unobserve(this)
        this.observer = new IntersectionObserver(
          (entries, observer) => {
            if (!entries[0].isIntersecting) return
            observer.unobserve(this)
            this.loadRecommendations(ids)
          },
          { rootMargin: '0px 0px 400px 0px' }
        )
        this.observer.observe(this)
      }

      loadRecommendations(ids) {
        const query = ids.map((id) => 'id:' + id).join(' OR ')

        fetch(
          `${this.dataset.searchUrl}?q=${encodeURIComponent(query)}&type=product&section_id=${this.dataset.sectionId}`
        )
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div')
            html.innerHTML = text
            const recommendations = html.querySelector(
              'recently-viewed-products'
            )

            if (!recommendations || !recommendations.innerHTML.trim().length) {
              if (!(window.Shopify && Shopify.designMode)) this.hideSection()
              return
            }

            this.reorderSlides(recommendations, ids)
            this.innerHTML = recommendations.innerHTML
          })
          .catch((error) => {
            console.error(error)
            if (!(window.Shopify && Shopify.designMode)) this.hideSection()
          })
      }

      // Reorder slides in the detached fragment before injecting — once
      // <collection-carousel> hits the live DOM its connectedCallback
      // initializes Swiper, and reordering slides after that corrupts it.
      reorderSlides(recommendations, ids) {
        const wrapper = recommendations.querySelector('.swiper-wrapper')
        if (!wrapper) return

        const slides = Array.from(
          wrapper.querySelectorAll('.swiper-slide')
        ).sort((a, b) => {
          const indexA = ids.indexOf(a.dataset.productId)
          const indexB = ids.indexOf(b.dataset.productId)
          return (
            (indexA === -1 ? ids.length : indexA) -
            (indexB === -1 ? ids.length : indexB)
          )
        })

        slides.forEach((slide) => wrapper.appendChild(slide))
      }

      hideSection() {
        const section = this.closest('.shopify-section')
        if (section) {
          section.hidden = true
        } else {
          this.hidden = true
        }
      }
    }
  )
}
